<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-head">Contents</p>
<p class="toc-front" id="copy-1"><span href="#/SeducedByARogu_copy" title="Link target outside of Sample">Copyright</span></p>
<p class="toc-front1" id="fore-1"><a href="#/SeducedByARogu_fore1">Author’s Note</a></p>
<p class="toc-chapter" id="chap-1"><a href="#/SeducedByARogu_chap1">Chapter 1</a></p>
<p class="toc-chapter" id="chap-2"><a href="#/SeducedByARogu_chap2">Chapter 2</a></p>
<p class="toc-chapter" id="chap-3"><a href="#/SeducedByARogu_chap3">Chapter 3</a></p>
<p class="toc-chapter" id="chap-4"><a href="#/SeducedByARogu_chap4">Chapter 4</a></p>
<p class="toc-chapter" id="chap-5"><a href="#/SeducedByARogu_chap5">Chapter 5</a></p>
<p class="toc-chapter" id="chap-6"><a href="#/SeducedByARogu_chap6">Chapter 6</a></p>
<p class="toc-chapter" id="chap-7"><a href="#/SeducedByARogu_chap7">Chapter 7</a></p>
<p class="toc-chapter" id="chap-8"><a href="#/SeducedByARogu_chap8">Chapter 8</a></p>
<p class="toc-chapter" id="chap-9"><a href="#/SeducedByARogu_chap9">Chapter 9</a></p>
<p class="toc-chapter" id="chap-10"><a href="#/SeducedByARogu_chap10">Chapter 10</a></p>
<p class="toc-chapter" id="chap-11"><a href="#/SeducedByARogu_chap11">Chapter 11</a></p>
<p class="toc-chapter" id="chap-12"><a href="#/SeducedByARogu_chap12">Chapter 12</a></p>
<p class="toc-chapter" id="chap-13"><a href="#/SeducedByARogu_chap13">Chapter 13</a></p>
<p class="toc-chapter" id="chap-14"><a href="#/SeducedByARogu_chap14">Chapter 14</a></p>
<p class="toc-chapter" id="chap-15"><a href="#/SeducedByARogu_chap15">Chapter 15</a></p>
<p class="toc-chapter" id="chap-16"><a href="#/SeducedByARogu_chap16">Chapter 16</a></p>
<p class="toc-chapter" id="chap-17"><a href="#/SeducedByARogu_chap17">Chapter 17</a></p>
<p class="toc-chapter" id="chap-18"><a href="#/SeducedByARogu_chap18">Chapter 18</a></p>
<p class="toc-chapter" id="chap-19"><a href="#/SeducedByARogu_chap19">Chapter 19</a></p>
<p class="toc-chapter" id="chap-20"><a href="#/SeducedByARogu_chap20">Chapter 20</a></p>
<p class="toc-front" id="teas-1"><a href="#/SeducedByARogu_teas1">A Preview of <em>Tempted by Warrior</em></a></p>
<p class="toc-front1" id="appe-2"><a href="#/SeducedByARogu_appe2">The Dish</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SeducedByARogu_toc.vue?3e7de60c